import {h, JSX} from 'preact';
import classNames from 'classnames'
import {CloseIcon} from './Icons';

export interface ModalProps {
    title: string;
    show: boolean;
    toggleModal: () => void;
    hasCloseButton?: boolean;
    children: JSX.Element[] | JSX.Element;
    containerClass?: string;
}

export const Modal = (props: ModalProps): JSX.Element => (
    <div
        className={'fixed inset-0 z-20 bg-black/60 whitespace-normal text-left flex flex-col p-4 md:p-8 lg:p-12' + (props.show ? '' : ' hidden')}
        id='confirmPurchase'
    >
        <div
            class={classNames(
                'bg-white w-full max-w-[480px] m-auto rounded-lg relative overflow-auto',
                props.containerClass
            )}
        >
            {props.hasCloseButton && (
                <div
                    class='absolute right-1 top-1 md:right-5 md:top-3.5 p-2 cursor-pointer rounded-full transition hover:bg-neutral-100'
                    onClick={props.toggleModal}>
                    <CloseIcon aria-hidden='true'/>
                </div>
            )}
            <h3
                class={classNames(
                    'border-b leading-[32px]',
                    props.hasCloseButton ? '!text-xl py-[21px] pl-8 pr-24' : 'py-6 px-8 text-center',
                )}
            >
                {props.title}
            </h3>
            <div class='w-full'>
                {props.children}
            </div>
        </div>
    </div>
);
